<script>
    import PrimaryButton from './PrimaryButton.svelte';
    export let buttonName;
    export let onClickHandler;
</script>

<PrimaryButton on:click={onClickHandler}>
    {buttonName}
</PrimaryButton>